import { render, staticRenderFns } from "./PluginInstallsReport.vue?vue&type=template&id=2a1188b2&"
import script from "./PluginInstallsReport.vue?vue&type=script&lang=js&"
export * from "./PluginInstallsReport.vue?vue&type=script&lang=js&"
import style0 from "./PluginInstallsReport.vue?vue&type=style&index=0&id=2a1188b2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports